import { Box } from '@mui/material';
import { VideoItem } from '../VideoCarousel/VideoCarouselModal';
import { HeroVideoSearchField } from './HeroVideoSearchField';
import { HeroVideoSearchResults } from './HeroVideoSearchResults';
import { HeroVideoSearchEmptyState } from './HeroVideoSearchEmptyState';

interface HeroVideoPickerProps {
  searchQuery: string;
  searchResults: VideoItem[];
  isSearching: boolean;
  onSearchQueryChange: (query: string) => void;
  onSelectVideo: (video: VideoItem) => void;
}

export function HeroVideoPicker({
  searchQuery,
  searchResults,
  isSearching,
  onSearchQueryChange,
  onSelectVideo,
}: HeroVideoPickerProps) {
  return (
    <Box>
      <HeroVideoSearchField
        value={searchQuery}
        isSearching={isSearching}
        onChange={onSearchQueryChange}
      />
      <HeroVideoSearchResults results={searchResults} onSelect={onSelectVideo} />
      {!searchQuery && <HeroVideoSearchEmptyState />}
    </Box>
  );
}
